import { createContext, useContext, useState, useEffect } from 'react';
import { UserContext } from '../components/Auth.jsx';

// Create the context
const CompanySettingsContext = createContext();

// Provider component
export const CompanySettingsProvider = ({ children }) => {
  const { user } = useContext(UserContext);
  const [selectedCompany, setSelectedCompany] = useState('no-company');
  const [selectedStore, setSelectedStore] = useState('no-store');

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedCompany = localStorage.getItem('zignyl-selected-company');
    const savedStore = localStorage.getItem('zignyl-selected-store');
    
    if (savedCompany) {
      setSelectedCompany(savedCompany);
    }
    if (savedStore) {
      setSelectedStore(savedStore);
    }
  }, []);

  // Reset selections when user changes (e.g., during impersonation)
  useEffect(() => {
    if (user) {
      // Reset to default selections when user changes
      setSelectedCompany('no-company');
      setSelectedStore('no-store');
      localStorage.setItem('zignyl-selected-company', 'no-company');
      localStorage.setItem('zignyl-selected-store', 'no-store');
    }
  }, [user?.id]); // Only trigger when user ID changes

  // Update company and save to localStorage
  const updateCompany = (companyId) => {
    setSelectedCompany(companyId);
    localStorage.setItem('zignyl-selected-company', companyId);
    
    // Reset store selection when company changes
    setSelectedStore('no-store');
    localStorage.setItem('zignyl-selected-store', 'no-store');
  };

  // Update store and save to localStorage
  const updateStore = (storeId) => {
    setSelectedStore(storeId);
    localStorage.setItem('zignyl-selected-store', storeId);
  };

  const value = {
    selectedCompany,
    selectedStore,
    updateCompany,
    updateStore
  };

  return (
    <CompanySettingsContext.Provider value={value}>
      {children}
    </CompanySettingsContext.Provider>
  );
};

// Custom hook to use the context
export const useCompanySettings = () => {
  const context = useContext(CompanySettingsContext);
  if (!context) {
    throw new Error('useCompanySettings must be used within a CompanySettingsProvider');
  }
  return context;
};
